import { ContractorTypeFields } from '../PersonsFields'
import { usePropertyInsuranceValues } from './PropertyInsuranceContext'
import { MIN_AGE } from './utils'

export const ContractorType = () => {
  const { isEditable } = usePropertyInsuranceValues()

  return (
    <ContractorTypeFields
      minAge={MIN_AGE}
      resident
      showSameContractorField={false}
      showBirthDate
      isEditable={isEditable}
    />
  )
}
